import { useState } from "react";
import { motion } from "framer-motion";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaSpinner, FaCheckCircle } from "react-icons/fa";

function GetInTouch() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    contact: "",
    company: "",
    message: ""
  });
  const [status, setStatus] = useState("idle"); // idle, loading, success, error

  const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbz1VarrXD8gBvouTxtaXlS1ez9IWx3qSZ7PH7RLpnDk4qu85FZoh1sg9_HpAbnZU_yijQ/exec";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const formBody = new URLSearchParams();
      Object.keys(formData).forEach(key => formBody.append(key, formData[key]));

      await fetch(SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: formBody.toString()
      });

      setStatus("success");
      setTimeout(() => {
        setStatus("idle");
        setFormData({ fullName: "", email: "", contact: "", company: "", message: "" });
      }, 3000);
    } catch (error) {
      console.error("Submission error details:", {
        message: error.message,
        url: SCRIPT_URL,
        stack: error.stack
      });
      setStatus("error");
    }
  };

  return (
    <section className="get-in-touch" id="contact-form">
      <div className="contact-info-col">
        <motion.div
          className="contact-header"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <span className="contact-tag">Get in touch</span>
          <h2>We are always ready to help you and answer your questions</h2>
          <p>Drop us a message anytime and we'll get back to you as soon as possible.</p>
        </motion.div>

        <motion.div
          className="contact-details-grid"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="contact-block">
            <h3>Contact Us </h3>
            <p>+91 63047 65654</p>
          </div>

          <div className="contact-block">
            <h3>Our Location</h3>
            <p>2nd Floor,</p>
            <p>Aikya Vihar,</p>
            <p>Kavuri Hills, Hyderabad, Telanagana, 500033 </p>
          </div>

          <div className="contact-block">
            <h3>Email</h3>
            <p>support@cabptoidsolutions.com </p>
          </div>


        </motion.div>
      </div>

      <motion.div
        className="contact-form-col"
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div className="contact-form-card">
          {status === "success" ? (
            <motion.div
              className="success-message"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              style={{ textAlign: 'center', padding: '40px 0' }}
            >
              <FaCheckCircle size={50} color="#42cfc0" style={{ marginBottom: '20px' }} />
              <h3>Message Sent!</h3>
              <p>Thank you for reaching out. We will contact you soon.</p>
            </motion.div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="fullName"
                placeholder="Full Name"
                className="pill-input"
                required
                value={formData.fullName}
                onChange={handleChange}
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                className="pill-input"
                required
                value={formData.email}
                onChange={handleChange}
              />
              <input
                type="tel"
                name="contact"
                placeholder="Contact Number"
                className="pill-input"
                required
                value={formData.contact}
                onChange={handleChange}
              />
              <input
                type="text"
                name="company"
                placeholder="Company Name"
                className="pill-input"
                value={formData.company}
                onChange={handleChange}
              />

              <textarea
                name="message"
                placeholder="How can we help you?"
                className="rounded-textarea"
                rows="4"
                required
                value={formData.message}
                onChange={handleChange}
              ></textarea>

              {status === "error" && (
                <p style={{ color: '#ff4d4d', fontSize: '14px', marginBottom: '10px' }}>
                  Oops! Something went wrong. Please try again.
                </p>
              )}

              <motion.button
                type="submit"
                className="submit-pill-btn"
                disabled={status === "loading"}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                {status === "loading" ? <FaSpinner className="spinner" /> : "Send message"}
              </motion.button>
            </form>
          )}
        </div>
      </motion.div>
    </section>
  );
}

export default GetInTouch;
